import { css } from "@emotion/css";
import { themeTokens } from "@octopusdeploy/design-system-tokens";
import type { ReactNode } from "react";
import type React from "react";
import { useRef } from "react";
import { createPortal } from "react-dom";
interface OverlayProps {
    children?: ReactNode;
    onClick?: () => void;
    isClosing?: boolean;
}
export function Overlay({ children, onClick, isClosing = false }: OverlayProps) {
    const divRef = useRef<HTMLDivElement>(null);
    const handleClick: React.MouseEventHandler = (event) => {
        if (event.target === divRef.current) {
            onClick?.();
        }
    };
    return createPortal(<div role={"presentation"} aria-label={"overlay"} ref={divRef} onClick={handleClick} className={`${overlayStyles} ${isClosing ? overlayClosingStyles : ""}`}>
            {children}
        </div>, document.body);
}
const overlayStyles = css({
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: themeTokens.color.overlay.primary,
    animation: "overlayFadeIn 200ms ease-in",
    "@keyframes overlayFadeIn": {
        from: {
            opacity: 0,
        },
        to: {
            opacity: 1,
        },
    },
});
const overlayClosingStyles = css({
    animation: "overlayFadeOut 200ms linear forwards",
    "@keyframes overlayFadeOut": {
        from: {
            opacity: 1,
        },
        to: {
            opacity: 0,
        },
    },
});
